<template>
  <div class="szw-flex szw-justify-center szw-items-center szw-w-full szw-min-h-[150px] szw-gap-4" :class="[{ 'szw-gap-8': !isSmallWidget }]">
    <cards-info :cards="cards.home" :classes="'szw-ml-auto'" />
    <donut :chart-data="chartData" :size="120" :radius="55" :color1="strokeColors.home" :color2="strokeColors.away" :stroke-width="10">
      <div
        class="szw-flex szw-flex-col szw-items-center szw-justify-center szw-absolute szw-inset-0 szw-text-text-icon-primary szw-h-full"
        :class="[{ 'szw-text-disable-light': !isDonutAvailable }]"
      >
        <div class="szw-flex szw-justify-between szw-items-center szw-gap-1">
          <span class="szw-font-semibold szw-text-2xl szw-w-9 szw-text-right">{{ chartData.left }}</span>

          <sprite sprite-id="goal" style="color: var(--szw-text-icon-tertiary)" />

          <span class="szw-font-semibold szw-text-2xl szw-w-9 szw-text-left">{{ chartData.right }}</span>
        </div>
        <div
          class="szw-flex szw-justify-center szw-items-center szw-text-center szw-w-20 szw-text-xxs szw-uppercase szw-break-words szw-leading-3 szw-font-normal szw-tracking-wider"
        >
          {{ chartDataTitle }} (%)
        </div>
      </div>
    </donut>
    <cards-info :cards="cards.away" :classes="'szw-mr-auto'" />
  </div>
</template>

<script setup>
import Donut from './Donut.vue'
import { computed, inject } from 'vue'
import { loc } from '@/__core__/localization/localization'
import CardsInfo from './CardsInfo.vue'
import Sprite from '@/__core__/components/sprite/Sprite.vue'

const props = defineProps({
  homeStats: {
    type: Object,
    required: true
  },
  awayStats: {
    type: Object,
    required: true
  }
})

const isSmallWidget = inject('isSmallWidget')
const langId = inject('langId', '')

const chartData = computed(() => ({
  left: props.homeStats['ball_possession']?.value?.replace(/%/g, '') || 0,
  right: props.awayStats['ball_possession']?.value?.replace(/%/g, '') || 0
}))

const chartDataTitle = computed(() => props.homeStats['ball_possession']?.label?.replace(/%/g, '') || '')

const isDonutAvailable = computed(() => chartData.value.left !== 0 && chartData.value.right !== 0)

const strokeColors = computed(() => {
  const colors = {
    home: 'var(--szw-team-home)',
    away: 'var(--szw-team-away)',
    disabled: 'var(--szw-disable-light)'
  }
  return {
    home: isDonutAvailable.value ? colors.home : colors.disabled,
    away: isDonutAvailable.value ? colors.away : colors.disabled
  }
})

const cards = computed(() => {
  return {
    home: {
      yellow: props.homeStats['live_ticker_yellow_card']?.value || '0',
      red: props.homeStats['live_ticker_red_card']?.value || '0',
      label: loc('sm_cards_given', langId)
    },
    away: {
      yellow: props.awayStats['live_ticker_yellow_card']?.value || '0',
      red: props.awayStats['live_ticker_red_card']?.value || '0',
      label: loc('sm_cards_given', langId)
    }
  }
})
</script>
